import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '@blueprint/ui';
import { AgentImageWrapper } from '../FeaturedProperties.styles';

const CTAWrapper = styled(AgentImageWrapper)(
    () => css`
        border-top: 0;

        ${Button} {
            margin: 0;
            line-height: initial;
        }
    `
);

export { CTAWrapper };
